/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipient_EmailInputs */

const da_privacy_recipient_email = /** @type {(inputs: Privacy_Recipient_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udsendelse af e-mail: bekræftelser, invitationer og påmindelser.`)
};

/** @type {(inputs: Privacy_Recipient_EmailInputs) => LocalizedString} */
const en_privacy_recipient_email = da_privacy_recipient_email;

/**

* @param {Privacy_Recipient_EmailInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipient_email = /** @type {((inputs?: Privacy_Recipient_EmailInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipient_EmailInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipient_email(inputs)
	return /** @type {LocalizedString} */ ("Udsendelse af e-mail: bekræftelser, invitationer og påmindelser.")
});